import React from "react";

interface ServiceSummaryErrorIconAttributes {
  className?: string;
}

export const ServiceSummaryErrorIcon: React.FC<
  ServiceSummaryErrorIconAttributes
> = ({ className = "" }: ServiceSummaryErrorIconAttributes) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="service-summary-error-icon"
    >
      <g clipPath="url(#clip0_12353_8206)">
        <path
          d="M16.0001 3.05762C8.64008 3.05762 2.66675 9.03095 2.66675 16.391C2.66675 23.751 8.64008 29.7243 16.0001 29.7243C23.3601 29.7243 29.3334 23.751 29.3334 16.391C29.3334 9.03095 23.3601 3.05762 16.0001 3.05762ZM17.3334 23.0576H14.6667V20.391H17.3334V23.0576ZM17.3334 17.7243H14.6667V9.72428H17.3334V17.7243Z"
          fill="#E70000"
        />
      </g>
      <defs>
        <clipPath id="clip0_12353_8206">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.390625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
